import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'

initializeIconsByRole({
  'csc-favorites-filter.icon': { name: 'heart', style: 'light' }
})

export class FavoritesChangeEvent extends Event {
  static type = 'favorites-change' as const

  checked: boolean

  constructor(checked: boolean) {
    super(FavoritesChangeEvent.type, { bubbles: true, composed: true })
    this.checked = checked
  }
}

@customElement('csc-favorites-filter')
export class CSCFavoritesFilter extends LitElement {
  static override styles: CSSResultGroup = [hostStyle]

  @property({ type: Boolean }) checked = false

  private handleToggleChange(event: Event): void {
    const toggle = event.target as HTMLInputElement
    this.checked = toggle?.checked ?? this.checked
    this.dispatchEvent(new FavoritesChangeEvent(this.checked))
  }

  override render() {
    return html`
      <cse-group class="csc-favorites-filter" alignment="center" justify="space-between">
        <cse-group alignment="center">
          <cse-icon icon-role="csc-favorites-filter.icon" size="lg"></cse-icon>
          <cse-text as="h4" variant="heading-4">
            ${t('title', { ns: 'csc-favorites-filter', default: 'My favorites' })}
          </cse-text>
        </cse-group>
        <cse-toggle
          ?checked=${this.checked}
          @change=${this.handleToggleChange}
          aria-label=${t('toggle_aria_label', { ns: 'csc-favorites-filter', default: 'Toggle My Favorites' })}
        ></cse-toggle>
      </cse-group>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-favorites-filter': CSCFavoritesFilter
  }

  interface GlobalEventHandlersEventMap {
    [FavoritesChangeEvent.type]: FavoritesChangeEvent
  }
}
